import styled, { css } from "styled-components";

import { borderRadius, colors, fontSize, space } from "shared/styles/constants";
import { Spacer } from "shared/layout";

interface SubscriptionCardContainerProps {
  isDisabled?: boolean;
}

export const SubscriptionCardContainer = styled.div<SubscriptionCardContainerProps>`
  background-color: ${colors.blackLight};
  width: 300px;
  border-radius: ${borderRadius.m};

  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.8;
    `}
`;

export const SubscriptionCardContent = styled(Spacer)`
  flex: 1;
  text-align: center;
  width: 100%;

  padding: ${space.l};

  align-items: center;
  justify-content: space-between;
`;

export const SubscriptionCardHeader = styled(SubscriptionCardContent)`
  background-color: ${colors.white5};
  flex: 0;

  width: 100%;
  border-radius: ${borderRadius.m} ${borderRadius.m} 0 0;
`;

export const SubscriptionCardHeaderPrice = styled.p`
  ${fontSize.base}
`;
